import React from "react";
import { OtcRequestItem } from "../../types";
import { PaymentInfoData } from "./PaymentInformationStep";
import { ProviderItem } from "./ProviderSelectionStep";
import { Button } from "../../../../shared/ui";
import { formatCurrencyAmount } from "../../../transactions/utils/formatCurrency";

export interface ReviewTransferDetailsStepProps {
  request: OtcRequestItem;
  provider: ProviderItem | null;
  paymentInfo: PaymentInfoData;
  onBack: () => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
}

export const ReviewTransferDetailsStep: React.FC<
  ReviewTransferDetailsStepProps
> = ({ request, provider, paymentInfo, onBack, onSubmit, isSubmitting }) => {
  const absAmount = Math.abs(Number(request.amount) || 0);
  const formattedSendAmount = formatCurrencyAmount(absAmount, request.currency);

  // const recipientToReceive = request.recipientToReceive || "-";
  // const agreedRate = request.offeredRate || request.requestedRate || "-";

  const recipientName =
    provider?.name ||
    request.recipientDetails?.name ||
    request.customer?.name ||
    "-";
  const recipientAccount =
    provider?.accountNumber ||
    request.recipientDetails?.accountNumber ||
    "-";

  const noteText = paymentInfo.note || request.notes || "-";

  return (
    <div className="flex flex-col gap-6">
      {/* Title */}
      <h2 className="text-[20px] font-semibold text-neutral-900">
        Review transfer details
      </h2>

      {/* Review details key-value list */}
      <div className="flex flex-col gap-4 text-[13px]">
        {/* You send */}
        <div className="flex items-center justify-between border-b border-neutral-100 pb-3.5">
          <span className="text-neutral-500">You send</span>
          <span className="text-[16px] font-bold text-neutral-900">
            {formattedSendAmount}
          </span>
        </div>

        {/* Recipient receives */}
        {/* <div className="flex items-center justify-between border-b border-neutral-100 pb-3.5">
          <span className="text-neutral-500">Recipient receives</span>
          <span className="font-semibold text-neutral-900">
            {recipientToReceive}
          </span>
        </div> */}

        {/* Agreed rate */}
        {/* <div className="flex items-center justify-between border-b border-neutral-100 pb-3.5">
          <span className="text-neutral-500">Agreed rate</span>
          <span className="font-medium text-neutral-900">{agreedRate}</span>
        </div> */}

        {/* Send to */}
        <div className="flex items-start justify-between border-b border-neutral-100 pb-3.5">
          <span className="text-neutral-500">Send to</span>
          <div className="flex flex-col items-end text-right">
            <span className="font-semibold text-neutral-900">
              {recipientName}
            </span>
            <span className="font-mono text-[12px] text-neutral-500">
              {recipientAccount}
            </span>
          </div>
        </div>

        {/* Notes */}
        <div className="flex items-start justify-between border-b border-neutral-100 pb-3.5">
          <span className="text-neutral-500">Notes</span>
          <span className="max-w-[260px] text-right font-medium text-neutral-900">
            {noteText}
          </span>
        </div>

        {/* Invoice */}
        <div className="flex items-center justify-between border-b border-neutral-100 pb-3.5">
          <span className="text-neutral-500">Invoice</span>
          <span className="font-medium text-neutral-900">
            {paymentInfo.invoiceFileName || "-"}
          </span>
        </div>

        {/* Supporting document */}
        <div className="flex items-center justify-between">
          <span className="text-neutral-500">Supporting document</span>
          <span className="font-medium text-neutral-900">
            {paymentInfo.supportingDocFileName || "-"}
          </span>
        </div>
      </div>

      {/* Actions */}
      <div className="mt-4 flex items-center justify-end gap-3 border-t border-neutral-100 pt-4">
        <button
          type="button"
          onClick={onBack}
          disabled={isSubmitting}
          className="h-10 rounded-[8px] px-4 py-2 text-[14px] font-medium text-neutral-700 transition-colors hover:text-neutral-900 disabled:opacity-50"
        >
          Back
        </button>
        <Button
          type="button"
          onClick={onSubmit}
          disabled={isSubmitting}
          className="px-6"
        >
          {isSubmitting ? "Submitting..." : `Send ${formattedSendAmount}`}
        </Button>
      </div>
    </div>
  );
};
